import React from "react";
import { RoleAccessRecordSnapshotType, TreeRow } from "../../models/access-store";
import { renderAsMenuRows } from "../FunctionalityTree";
import styles from "./AccessModule.module.scss";

export const AccessModule = ({ name, functionalities, access, onToggle }: AccessModuleProps) => {
  // const renderer = renderRows(false, true, (row, key) => {
  //     const value = access.find((a) => a.name === row.functionality);
  //     const can = !!value && value.value;

  //     return (
  //         <td
  //             className={value && value.overwritten ? "access-value overwritten" : "access-value"}
  //             style={{ width: "30px", minWidth: "30px", textAlign: "center" }}
  //             key={key}
  //             onClick={() => onToggle(row.functionality, !can)}
  //         >
  //             {can && <Icon icon="tick" />}
  //         </td>
  //     );
  // });

  const renderer = (row: number, key: TreeRow[]) => {
    return renderAsMenuRows(row, key, access, onToggle);
  };

  return (
    <div className={`${styles.module}`}>
      <div className={styles.content}>{renderer(-1, functionalities)}</div>
    </div>
  );
};

interface AccessModuleProps {
  functionalities: TreeRow[];
  name: string;
  access: RoleAccessRecordSnapshotType[];
  onToggle: (functionality: string, state: boolean) => void;
  startLevel?: number;
}
